import { Controller } from '@hotwired/stimulus';

export class ParamsController extends Controller {
  static targets = ['link'];
  static values = {
    linkAttribute: {
      default: 'href',
      type: String,
    },
  };

  set(event) {
    const {
      name = event.target.name,
      value = event.target.value,
    } = event.params;

    if (this.hasLinkTarget) {
      this.linkTargets.forEach(link => link.setAttribute(
        this.linkAttributeValue,
        this.setParam(link.getAttribute(this.linkAttributeValue), name, value)
      ));

      return;
    }

    window.history.pushState(window.history.state, null, this.setParam(window.location.href, name, value));
  }

  setParam(url, name, value) {
    const newUrl = new URL(url);

    newUrl.searchParams.set(name, value);

    return newUrl.toString();
  }
}
